import type { Ref } from 'react';
import type { ElementType, HTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export type TitleElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';

export interface TitleProps extends HTMLAttributes<HTMLElement> {
  as?: TitleElement;
  size?: 'default' | 'lg';
}

export function Title(
  { ref, as: asProp = 'h2', size = 'default', className, children, ...rest }: TitleProps & { ref?: Ref<HTMLElement> },
) {
  const Component = asProp as ElementType;
  return (
    <Component ref={ref} className={cx('title', size === 'lg' && 'title--lg', className)} {...rest}>
      {children}
    </Component>
  );
}
